var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipsisClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 14.5C15.5562 14.5 14.9 15.2031 14.9 16C14.9 16.8438 15.5562 17.5 16.4 17.5C17.1968 17.5 17.9 16.8438 17.9 16C17.9 15.2031 17.1968 14.5 16.4 14.5ZM14.9 10.375C14.9 11.2188 15.5562 11.875 16.4 11.875C17.1968 11.875 17.9 11.2188 17.9 10.375C17.9 9.57812 17.1968 8.875 16.4 8.875C15.5562 8.875 14.9 9.57812 14.9 10.375ZM14.9 21.625C14.9 22.4688 15.5562 23.125 16.4 23.125C17.1968 23.125 17.9 22.4688 17.9 21.625C17.9 20.8281 17.1968 20.125 16.4 20.125C15.5562 20.125 14.9 20.8281 14.9 21.625Z",
    fill: "#256BF7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisClear);
export default __webpack_public_path__ + "static/media/ellipsis-clear.dc00f22a754a565217b90a6afdf3a095.svg";
export { ForwardRef as ReactComponent };